// 导出配置的路由器
export default [{
    path: '/profitCenter',
    component: () =>
        import ('@/layout/index'),
    redirect: 'profitCenter/commission',
    meta: {
        title: '分润中心',
        icon: 'icon-yingxiao1',
        perms: ['bee:profitCenter']
    },
    // hidden: true,
    children: [{
        path: 'profit',
        component: () =>
            import ('@/module/profitCenter/page/profit/manage.vue'),
        meta: {
            title: '分润管理',
            icon: 'icon-guanggao',
            perms: ['bee:profit:administration']
        }
    }, {
        path: 'investment',
        component: () =>
            import ('@/module/profitCenter/page/investment/manage.vue'),
        meta: {
            title: '我的投资',
            icon: 'icon-guanggao',
            perms: ['bee:profit:investment']
        }
    }, {
      path: 'dataManager',
      component: () =>
        import ('@/module/profitCenter/page/dataManager/manage.vue'),
      meta: {
        title: '分润数据管理',
        icon: 'icon-guanggao',
        perms: ['bee:profit:datamanager']
      }
    }, {
        path: 'paymentAudit',
        component: () =>
            import ('@/module/profitCenter/page/paymentAudit/manage.vue'),
        meta: {
            title: '转账汇款',
            icon: 'icon-guanggao',
            perms: ['bee:profit:remittance']
        }
    }]
}]


// WEBPACK FOOTER //
// ./src/module/profitCenter/router/index.js